import * as HLF from "html-living-framework";
import {Container} from "../core/Container";
import {Spine} from "../core/Spine";
import {Assets} from "../data/Assets";
import {CaptionToken} from "../data/CaptionToken";
import {CharacterType} from "../data/CharacterType";
import * as Topics from "../data/Topics";

export class Character extends Container {

    public readonly characterType: CharacterType;
    public readonly characterSpine: Spine;

    private isTalking = false;
    private isRunning = false;

    constructor(characterType: CharacterType) {
        super();

        this.characterType = characterType;
        this.characterSpine = this.addChild(new Spine(
            Assets.characters[this.characterType]!.getAsset(),
        ));

        this.characterSpine.setMixes(0);
        this.characterSpine.setMixes(0.25, "climb_up", "pullup");
        this.characterSpine.setMixes(0.25, "Talk", "idle");
        this.characterSpine.autoUpdate = true;
        this.characterSpine.state.timeScale = 1.5;
        this.animateIdle();

        PubSub.subscribe(Topics.PLAY_CAPTION, this.onPlayCaption);
        PubSub.subscribe(Topics.STOP_CAPTION, this.onStopCaption);

        PubSub.subscribe(HLF.GAME_PAUSED, this.onPause);
        PubSub.subscribe(HLF.GAME_UNPAUSED, this.onResume);
    }

    public startTalk() {
        if (!this.isTalking) {
            this.isTalking = true;
            const anim = this.characterSpine.getCurrentAnimation();
            if (anim && anim.animation.name === "idle") {
                this.animateIdle();
            }
        }
    }

    public stopTalk() {
        if (this.isTalking) {
            this.isTalking = false;
            const anim = this.characterSpine.getCurrentAnimation();
            if (anim && anim.animation.name === "Talk") {
                this.animateIdle();
            }
        }
    }

    public startRun() {
        if (!this.isRunning) {
            this.isRunning = true;
            this.characterSpine.animate("run", true);
        }
    }

    public stopRun() {
        if (this.isRunning) {
            this.isRunning = false;
            this.characterSpine.animate("stop", () => {
                this.animateIdle();
            });
        }
    }

    public destroy() {
        PubSub.unsubscribe(this.onPlayCaption);
        PubSub.unsubscribe(this.onStopCaption);
        PubSub.unsubscribe(this.onPause);
        PubSub.unsubscribe(this.onResume);
        super.destroy();
    }

    private readonly onPlayCaption = (topic: string, token: CaptionToken) => {
        if (token && token.id && (
            token.id.toLowerCase().indexOf(this.characterType + "_") >= 0 ||
            token.id.toLowerCase().indexOf("_" + this.characterType) >= 0)) {
            this.startTalk();
        } else {
            this.stopTalk();
        }
    }

    private readonly onStopCaption = () => {
        this.stopTalk();
    }

    private readonly onPause = () => {
        this.characterSpine.autoUpdate = false;
    }

    private readonly onResume = () => {
        this.characterSpine.autoUpdate = true;
    }

    private animateIdle() {
        if (this.isTalking) {
            // Fix of Xavier red face when transitioning from idle looking right to talk animation
            this.characterSpine.stop();
            this.characterSpine.animate("idle", true);
            const track = this.characterSpine.animate("Talk", true);
            track.timeScale = 0.6;
        } else {
            this.characterSpine.animate("idle", true);
        }
    }
}

export class Xavier extends Character {

    constructor() {
        super(CharacterType.Xavier);
    }
}

export class Brad extends Character {

    constructor() {
        super(CharacterType.Brad);
    }
}

export class Yadina extends Character {

    constructor() {
        super(CharacterType.Yadina);
        this.characterSpine.scale.x = -this.characterSpine.scale.x;
    }
}

export const Characters = {
    [CharacterType.Brad]: Brad,
    [CharacterType.Yadina]: Yadina,
    [CharacterType.Xavier]: Xavier,
};
